import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PartySource } from '@shared/party/enums';
import { PartyBadge } from '../../models/party-badge';

@Component({
  selector: 'tablesready-party-badge',
  templateUrl: './party-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PartyBadgeComponent {
  @Input() party?: PartyBadge;
  @Input() showTypeBadge = true;
  partySources = PartySource;
}
